export default __webpack_public_path__ + "static/media/Amrit.fe1ea3d0.png";